import { render, staticRenderFns } from "./hover-click-popup.vue?vue&type=template&id=62947daa&scoped=true&"
import script from "./hover-click-popup.vue?vue&type=script&lang=js&"
export * from "./hover-click-popup.vue?vue&type=script&lang=js&"
import style0 from "./hover-click-popup.vue?vue&type=style&index=0&id=62947daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62947daa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VMenu})
